import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";
import { ProgressBar } from "@/components/ProgressBar";
import { StatusChip } from "@/components/StatusChip";

export default function ProgressPage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/nurse/dashboard").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!data) return <Loader />;

  return (
    <div className="space-y-5" data-testid="nurse-progress">
      <h1 className="text-[24px] font-bold text-[#1c1b1b]">Your Progress</h1>
      <div className="bg-white rounded-lg border border-[#E5E7EB] p-5">
        <div className="flex justify-between items-center mb-3">
          <span className="font-semibold text-[#1c1b1b]">Overall</span>
          <span className="text-[28px] font-bold text-[#003d9b]">{data.overall_progress}%</span>
        </div>
        <ProgressBar value={data.overall_progress} />
        <p className="text-sm text-[#434654] mt-2">{data.completed_modules} of {data.total_modules} modules completed</p>
      </div>
      <div className="space-y-3">
        {data.modules.map((m) => (
          <button key={m.id} onClick={() => navigate(`/app/modules/${m.id}`)} data-testid={`progress-module-${m.id}`}
            className="w-full text-left bg-white rounded-lg border border-[#E5E7EB] p-4 flex items-center justify-between hover:border-[#003d9b] transition-colors">
            <div>
              <p className="font-semibold text-[#1c1b1b]">{m.title}</p>
              <p className="text-xs text-[#434654] mt-1">
                PPT {m.ppt_completed ? "✓" : "—"} · Video {m.video_completed ? "✓" : "—"}
              </p>
            </div>
            <StatusChip status={m.status} />
          </button>
        ))}
        {data.modules.length === 0 && <p className="text-sm text-[#434654]">No modules assigned yet.</p>}
      </div>
    </div>
  );
}
